import rnPushTokenProvider from '@/features/push/providers/rn-push-token-provider';
import webPushTokenProvider from '@/features/push/providers/web-push-token-provider';
import type PushTokenProvider from '@/features/push/types/push-token-provider';

export default function getPushTokenProvider(): PushTokenProvider {
  return window.ReactNativeWebView ? rnPushTokenProvider : webPushTokenProvider;
}
